<template>
  <div class="buy_history_box">
    <div v-if="list.length">
      <TableC
        :columns="columns" :list="list" align="center" lineHeight="60"
        lineHeight-head="95" class="buy_table" @click.native="report(6)">
        <template v-slot:info>
          <!-- <template v-slot:info="{ info }"> -->
          <span class="btn_active" @click.stop="clickInvoicing">点击开票</span>
        <!-- <span v-if="info.status === 0" class="btn_active" @click="clickInvoicing">点击开票</span>
        <span v-if="info.status === 1" class="btn_wait">等待开票</span>
        <span v-if="info.status === 2">已超期，不可开票</span> -->
        </template>
      </TableC>
      <p class="help_p">如有任何问题，可直接联系客服</p>
    </div>
    <NoData v-else :area="3">您还没有产生消费记录</NoData>
  </div>
</template>

<script>
import TableC from './Table.vue'
import NoData from './NoData.vue'

import { customerUrl } from '@/common/resources.js'
import { floatMul } from '@shared/utils/base/src/number.js'
import api from '@/api'
import { reportAction } from '@/report/index.js'

import { ClientOpenUrlByBroswer } from '@/api/clientApi.js'

export default {
  name: 'OrderHistory',

  components: { TableC, NoData },

  data () {
    return {
      columns: [
        { prop: 'pay_time', label: '充值时间' },
        { prop: 'summery', label: '会员等级' },
        { prop: 'money', label: '充值金额', func: (price) => floatMul(price, 0.01) },
        { prop: 'info', label: '开票信息', type: 'slot' }
      ],
      list: []
    }
  },

  mounted () {
    this.getOrderList()
  },

  methods: {
    getOrderList () {
      api.user.pays().then(res => {
        this.list = res.data.pay_infos || []
      })
    },

    clickInvoicing () {
      this.report(5)
      ClientOpenUrlByBroswer(customerUrl)
    },

    report (area, pos = '') {
      reportAction({ actiontype: 2, area, pos })
    }
  }
}
</script>

<style lang="scss" scoped>
.buy_history_box {
  .buy_table {
    width: 100%;
  }
  .btn_active {
    color: $default_primary_color;
    cursor: pointer;
  }
  .help_p {
    padding: 20px 0;
    font-size: 14px;
    font-weight: 400;
    color: #666;
    text-align: center;
  }
  .btn_wait {
    color: #999;
  }
}
</style>
